import {
    authorizeBroadcastChannel,
    broadcastingAuthEndpoint,
} from "@/utils/broadcastingAuthorizer";
import Echo from "laravel-echo";

import Pusher from "pusher-js";

declare global {
    interface Window {
        Pusher: typeof Pusher;
        Echo: Echo<"pusher">;
    }
}

window.Pusher = Pusher;

window.Echo = new Echo({
    broadcaster: "pusher",
    key: import.meta.env.VITE_PUSHER_APP_KEY,
    cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER,
    forceTLS: true,
    channelAuthorization: {
        endpoint: broadcastingAuthEndpoint(),
        transport: "ajax",
        customHandler: authorizeBroadcastChannel,
    },
});
